// extracted by mini-css-extract-plugin
export default {"base":"base-HNhLo","active":"active-WYOWM","text":"text-VBhnH"};